import { CoreIcon } from '../core-icon';
import checkCircleFillSVG from '../../assets/icons/check-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const CheckCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={checkCircleFillSVG} {...props} />;
};
